import { render, staticRenderFns } from "./OpenReserve.vue?vue&type=template&id=2ad81f91&scoped=true&"
import script from "./OpenReserve.vue?vue&type=script&lang=js&"
export * from "./OpenReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad81f91",
  null
  
)

export default component.exports